import React, { Component } from 'react'
import config from '../../config';

import {
    FacebookShareButton,
    TwitterShareButton,
  } from 'react-share';

export default class Share extends Component {
  render() {
    return (
      <div>
        <div className="icon">
                                        <ul>
                                           <li>
                                                <FacebookShareButton
                                                    url={config.share.url}
                                                    quote={config.share.title}>
                                                      {/* eslint-disable-next-line  */}
                                                    <a href="#"><i className="fab fa-facebook-f"></i></a>
                                                </FacebookShareButton>   
                                            </li>
                                            <li>
                                                <TwitterShareButton
                                                    url={config.share.url}
                                                    quote={config.share.title}>
                                                      {/* eslint-disable-next-line  */}
                                                    <a href="#"><i className="fab fa-twitter"></i></a>
                                                </TwitterShareButton>   
                                            </li>
                                        </ul>
                                    </div>
      </div>
    )
  }
}
